import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Header from "../../components/Header";
import FormListItem from "../../components/FormListItem";
import * as AppActions from "../../actions";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Grid } from "semantic-ui-react";
import _ from "lodash";

class DraftsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastRefresh: Date(Date.now()).toString(),
      width: 800,
      height: 182
    };
    this.refreshScreen = this.refreshScreen.bind(this);
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  updateDimensions() {
    let update_width = window.innerWidth;
    let update_height = window.innerHeight;
    this.setState({ width: update_width, height: update_height });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  handleBack() {
    return true;
  }

  refreshScreen() {
    if (this.props.isConnected) {
      this.setState({ lastRefresh: Date(Date.now()).toString() });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const { actionQueue, storeId, test } = this.props;
    if (this.state.lastRefresh !== nextState.lastRefresh) {
      const { actions } = this.props;
      let check = _.filter(actionQueue, {
        saved: false,
        storeId: storeId,
        isDraft: true,
        test: test
      });
      if (check.length === 0) {
        actions.readDrafts();
      }
    }
    return true;
  }

  componentWillMount() {
    const { actions, isConnected } = this.props;

    if (isConnected) {
      actions.readDrafts();
    }
  }

  handleClick(form_id, form_title, icon_path, form_version, uuid, approval_enabled, notification_id) {
    var form = _.filter(this.props.actionQueue, {
      uuid: uuid,
      test: this.props.test
    });

    this.props.actions.cloneImages(uuid);
    this.props.actions.updateFormTitle(
      form_title,
      form_version,
      icon_path,
      form_id
    );
    let recovered = false;
    if (
      this.props.recovered_form.length !== 0 &&
      this.props.recovered_formId === form_id &&
      this.props.recovered_draft === true
    ) {
      recovered = true;
      this.props.actions.setWorkingDraft(this.props.recovered_form, "");
    } else {
      this.props.actions.setWorkingDraft(form[0].draft, uuid);
    }

    this.props.history.push(
      `/form/${form_id}/${uuid}/${false}/${recovered}/${
        form[0].draftName
      }/${form_version}/${form[0].result_id}/${notification_id}/${false}`
    );
  }

  handleDeleteDraft(uuid, result_id) {
    let server_id = result_id;

    const options = {
      title: "Confirm",
      message: "Are you sure you want to delete this form?",
      buttons: [
        {
          label: "OK",
          onClick: () => {
            this.props.actions.deleteDraft(uuid, server_id);
          }
        },
        {
          label: "Cancel",
          onClick: () => {}
        }
      ]
    };

    confirmAlert(options);
  }

  getForms() {
    const { storeColour, storeId, test } = this.props;

    var forms = _.filter(this.props.actionQueue, function(q) {
      return q.draftName !== "" && q.storeId === storeId && q.test === test;
    });

    var formsOrdered = _.sortBy(forms, [form => Date(form.data_added)], "desc");
    var forms = [];

    formsOrdered.forEach((form, index) => {
      forms.push(
        <FormListItem
          storeColour={storeColour}
          container="Drafts"
          onDelete={this.handleDeleteDraft.bind(this)}
          onClick={this.handleClick.bind(this)}
          {...form}
          key={index}
        />
      );
    });

    if (forms.length === 0) {
      return <div></div>;
    }

    return (
      <div className="formSectionContainerX">
        <form className="ui formList">
          <Grid columns={6} doubling>
            <Grid.Row>{forms}</Grid.Row>
          </Grid>
        </form>
        <br />
        <br />
        <br />
      </div>
    );
  }
  render() {
    let y = this.state.height - 50 + "px";

    const { actions } = this.props;
    return (
      <div>
        <Header
          formTitle={"Drafts"}
          onRefresh={this.refreshScreen}
          setSidebarVisibility={actions.setSidebarVisibility}
        ></Header>
        <div
          className="formsBackground"
          style={{ height: y, overflowY: "scroll" }}
        >
          {this.getForms()}
        </div>
      </div>
    );
  }
}

DraftsContainer.propTypes = {
  sessionId: PropTypes.string.isRequired,
  forms: PropTypes.array.isRequired,
  sort: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  sessionId: state.informedWebApp.sessionId,
  deviceId: state.informedWebApp.deviceId,
  isLoading: state.informedWebApp.isLoading,
  storeColour: state.informedWebApp.storeColour,
  forms: state.forms.data,
  isConnected: state.informedWebApp.isConnected,
  actionQueue: state.informedWebApp.actionQueue,
  storeId: state.informedWebApp.storeId,
  recovered_form: state.forms.recovered_form,
  recovered_formId: state.forms.recovered_formId,
  recovered_uuid: state.forms.recovered_uuid,
  recovered_draft: state.forms.recovered_draft,
  test:
    state.informedWebApp.api === "https://www.in-formed.co.uk/api.php"
      ? false
      : true,
  sort: state.forms.sort
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DraftsContainer)
);



// WEBPACK FOOTER //
// ./src/containers/DraftsContainer/index.js